module.exports = __webpack_public_path__ + "media/images/CHA-06-226cf3f527246629bc0f7894550307ac.jpg";